/* ==========================================================================
   GOODS SCENE -- PDP REVIEWS + COMMUNITY
   1. write-a-review proxy
   2. reviewer initials + stable avatar colour (presentation only)
   3. merchant reply: drop the leading ">>" text node (presentation only)
   4. zero-review products: collapse the empty Judge.me shell (presentation only)
   5. top rating row -> scrolls to Customer Reviews (behaviour only)

   🛑 NOTHING HERE CHANGES REVIEW DATA. No node is created, removed, moved or
   cloned; no href, data-mfp-src, aria-*, role or tabindex is touched. The
   popup, the form, photo upload, the lightbox, sorting, helpful voting and
   pagination all stay inside Judge.me. The author element is only READ.
   ========================================================================== */

(function () {
  var SECTION = '.shopify-section[id$="__171872593513237d9e"]';
  var JDGM_WRITE = '.jdgm-write-rev-link';

  /* 🛑 JUDGE.ME NEEDS A WARM-UP CLICK AND THEN REAL TIME. Proven in the browser
     on a fresh zero-review product: .jdgm-write-rev-link already EXISTS before
     any click; forcing it visible changes nothing; the first .click() does not
     open the form; a SECOND click fired synchronously does not open it either;
     a second click after setTimeout(..., 0) does not open it; a second click
     after 100ms DOES. Judge.me's initialisation is genuinely asynchronous and
     does not complete within a microtask or a macrotask turn.

     🛑 THAT IS WHY THERE IS A TIMER HERE, AND WHY TWO EARLIER ATTEMPTS FAILED.
     The first patch armed a flag only when the link was ABSENT -- a branch this
     bug never reaches. The second waited on the existing MutationObserver, but
     the warm-up produces no mutation inside the observed section, so the pass
     never ran. Both have been removed rather than left as dead code. A delay is
     not a workaround here; it is the only thing the evidence supports.

     ⚠️ ONE SHOT, ONCE PER PAGE LOAD. writeReviewPrimed is set BEFORE the timer
     is armed, so a second user click during the 150ms falls straight through to
     the direct path and no second timer can ever exist. */
  var writeReviewPrimed = false;

  /* ------------------------------------------------------------------------
     WRITE A REVIEW PROXY
     ------------------------------------------------------------------------ */

  /* 🔑 THE LOOKUP HAPPENS AT CLICK TIME, NEVER AT INIT. Judge.me renders
     asynchronously, so caching the button at startup would capture null.

     🛑 preventDefault ON EVERY PATH. The control's href is only "#", because a
     JSON template wraps sections as shopify-section-template--<instance
     id>__<section id> and the instance prefix differs between the CN and EU
     templates, so no literal anchor is correct in both. */

  /* 🔑 THE ZERO-REVIEW TEST IS THE THEME'S OWN LIQUID MARKER, NEVER VISIBILITY.
     .gs-rc__summary--empty is rendered only in the else branch of
     `review_count > 0`, from product.metafields.reviews.rating_count. It is the
     same marker hideZeroReviewWidget already gates on, so there is one source of
     truth. ⚠️ Never infer this from display, height or the absence of .jdgm-rev:
     the widget is hidden by our own CSS on exactly these pages. */
  function isZeroReviewPage() {
    return !!document.querySelector('.gs-rc__summary--empty');
  }

  function onWriteClick(event) {
    /* Every path below ends here anyway -- the href is only "#". */
    event.preventDefault();

    var official = document.querySelector(JDGM_WRITE);

    if (official && typeof official.click === 'function') {
      /* 🛑 THE WARM-UP IS SCOPED TO ZERO-REVIEW PAGES AND RUNS ONCE. A product
         WITH reviews has a fully attached widget on first paint, so it keeps the
         single direct click it has always had -- this branch is not reached
         there at all. Once primed, this page also returns to one click. */
      if (!writeReviewPrimed && isZeroReviewPage()) {
        /* 🔑 SET FIRST, ARM SECOND. This is what makes the timer un-repeatable:
           by the time anything else can run, this page is already primed. */
        writeReviewPrimed = true;

        official.click();

        /* ⚠️ THE CAPTURED REFERENCE IS USED DELIBERATELY, NOT RE-QUERIED. The
           browser proof clicked the SAME element twice; re-querying would be a
           different, untested code path. If Judge.me ever replaces the node
           inside these 150ms this reference goes stale -- re-measure before
           changing it.

           ⚠️ 150ms IS THE MEASURED FLOOR PLUS HEADROOM: 0ms failed, 100ms
           worked. Do not tune it down without repeating that test. */
        setTimeout(function () {
          official.click();
        }, 150);

        return;
      }

      official.click();
      return;
    }

    /* ⚠️ NO FLAG ON THIS PATH. The link is absent, so there is nothing to warm
       up and nothing for the pass to consume; scrolling is all this can do. The
       previous build armed the flag here, which is precisely why it never fired
       -- on the real bug the link is already present and this branch is dead. */
    var section = document.querySelector(SECTION);
    if (section && typeof section.scrollIntoView === 'function') {
      section.scrollIntoView({ block: 'start' });
    }
  }

  function initProxy(root) {
    var controls = (root || document).querySelectorAll('[data-gs-write-review]');

    for (var i = 0; i < controls.length; i++) {
      var el = controls[i];
      if (el.dataset.gsWriteReviewReady === 'true') continue;
      el.dataset.gsWriteReviewReady = 'true';
      el.addEventListener('click', onWriteClick);
    }
  }

  /* ------------------------------------------------------------------------
     REVIEWER INITIALS AND AVATAR COLOUR
     ------------------------------------------------------------------------ */

  /* 🛑 CSS CANNOT DO THIS, WHICH IS THE ONLY REASON THERE IS JS HERE.
     .jdgm-rev__icon is empty at runtime and its glyph comes from Judge.me
     pseudo-elements, so attr() has nothing to read. This writes two data
     attributes the stylesheet then uses. */
  function initialsFrom(name) {
    var clean = (name || '').replace(/\s+/g, ' ').trim();
    if (!clean) return '';

    var parts = clean.split(' ');

    /* Two or more words: first letter of the first and of the last. */
    if (parts.length > 1) {
      var a = parts[0].replace(/[^A-Za-z0-9]/g, '').charAt(0);
      var b = parts[parts.length - 1].replace(/[^A-Za-z0-9]/g, '').charAt(0);
      return (a + b).toUpperCase();
    }

    /* One token, possibly punctuated like "H.I": first two letters it has. */
    return clean.replace(/[^A-Za-z0-9]/g, '').slice(0, 2).toUpperCase();
  }

  /* 🔑 DETERMINISTIC, NOT RANDOM, AND NOT POSITIONAL. The same reviewer always
     lands on the same palette slot, so the colour survives sorting, pagination
     and Load more. :nth-child() would have re-coloured everyone the moment the
     order changed. This is a small stable accumulator, not a security hash. */
  function colorIndexFrom(name) {
    var clean = (name || '').replace(/\s+/g, ' ').trim().toUpperCase();
    var h = 0;

    for (var i = 0; i < clean.length; i++) {
      h = (h * 31 + clean.charCodeAt(i)) % 100000;
    }

    return String(h % 6);
  }

  /* ⚠️ ALWAYS SCANS FROM THE SECTION, NEVER FROM A PASSED-IN ROOT. An earlier
     build took a root argument and, on the shopify:section:load path, received
     a subtree that did not contain the widget. */
  function applyInitials() {
    var section = document.querySelector(SECTION);
    if (!section) return;

    var reviews = section.querySelectorAll('.jdgm-rev');

    for (var i = 0; i < reviews.length; i++) {
      var rev = reviews[i];
      var icon = rev.querySelector('.jdgm-rev__icon');
      var author = rev.querySelector('.jdgm-rev__author');
      if (!icon || !author) continue;

      var value = initialsFrom(author.textContent);
      /* Empty or unreadable name: leave Judge.me's own glyph alone. */
      if (!value) continue;
      if (icon.getAttribute('data-gs-initials') === value) continue;

      icon.setAttribute('data-gs-initials', value);
      icon.setAttribute('data-gs-avatar-color', colorIndexFrom(author.textContent));
    }
  }

  /* ------------------------------------------------------------------------
     MERCHANT REPLY -- LEADING ">>"
     ------------------------------------------------------------------------ */

  /* 🛑 THE ONLY THING TOUCHED IS THE LEADING PUNCTUATION OF ONE TEXT NODE.
     Runtime structure of .jdgm-rev__replier-wrapper:

       TEXT  ">> "
       <b class="jdgm-rev__replier">Goods Scene</b>
       TEXT  " replied:"

     "replied:" lives in the LAST text node and is Judge.me's localised wording,
     so it is never read, rewritten or synthesised. No node is created, removed
     or moved -- one nodeValue is trimmed in place.

     🔑 CSS COULD NOT DO THIS. There is no selector for "the first text node",
     and the earlier font-size: 0 attempt hid "replied:" along with the arrows.

     ⚠️ ONLY THE FIRST MEANINGFUL TEXT NODE, AND ONLY IF IT MATCHES. If Judge.me
     ever drops the arrows, or an element comes first, the loop breaks having
     changed nothing. */
  function stripReplyPrefix() {
    var section = document.querySelector(SECTION);
    if (!section) return;

    var wrappers = section.querySelectorAll('.jdgm-rev__replier-wrapper');

    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      if (wrapper.getAttribute('data-gs-reply-clean') === 'true') continue;

      var nodes = wrapper.childNodes;

      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];

        /* An element before any text: nothing to strip, leave it alone. */
        if (node.nodeType !== 3) break;

        /* Pure whitespace between nodes is not the node we mean. */
        if (!/\S/.test(node.nodeValue)) continue;

        node.nodeValue = node.nodeValue.replace(/^\s*>>\s*/, '');
        wrapper.setAttribute('data-gs-reply-clean', 'true');
        break;
      }
    }
  }

  /* ------------------------------------------------------------------------
     ZERO-REVIEW EMPTY WIDGET
     ------------------------------------------------------------------------ */

  /* 🔑 THE ZERO-REVIEW SOURCE IS LIQUID, NEVER JUDGE.ME. The GS section renders
     .gs-rc__summary--empty ONLY inside the else branch of `review_count > 0`,
     and review_count is product.metafields.reviews.rating_count. Judge.me's own
     "No reviews" wording is never read, and the absence of .jdgm-rev is never
     treated as evidence of anything.

     🛑 THE GATE IS JUDGE.ME'S OWN CONTROL. Nothing is marked until
     .jdgm-write-rev-link exists INSIDE the section, which only happens once the
     widget has initialised. On first paint the shell is untouched, so a widget
     that is still loading is never hidden out from under itself.

     ⚠️ NO NODE IS REMOVED AND NOTHING IS DISABLED. One attribute is set and the
     stylesheet collapses the card. The official button stays in the DOM and
     stays clickable for the top Write a review proxy.

     ⚠️ FAILS OPEN AT EVERY STEP. No marker, no section, no app block, or no
     write link yet -> return, and the card stays exactly as it is. */
  function hideZeroReviewWidget() {
    if (!document.querySelector('.gs-rc__summary--empty')) return;

    var section = document.querySelector(SECTION);
    if (!section) return;

    var block = section.querySelector('.shopify-app-block');
    if (!block) return;
    if (block.getAttribute('data-gs-zero-review-widget') === 'true') return;

    /* Judge.me has not rendered yet: leave it and wait for the next pass. */
    if (!section.querySelector(JDGM_WRITE)) return;

    block.setAttribute('data-gs-zero-review-widget', 'true');
  }

  /* ------------------------------------------------------------------------
     TOP RATING ROW -> CUSTOMER REVIEWS
     ------------------------------------------------------------------------ */

  /* 🛑 THREE SIBLINGS, NO WRAPPER, AND NONE IS CREATED. main-product.liquid emits
     .rating, .rating-text and .rating-count as separate children of
     <product-info>. Wrapping them would mean moving three Dawn nodes, so instead
     all three get the listener and only ONE carries the semantics.

     🔑 .rating-count IS THE KEYBOARD CONTROL, AND ONLY IT. Three tabbable
     siblings for one destination would be worse than no keyboard support at all.
     Its visible text is its accessible name, so no English is invented here.

     ⚠️ .rating IS role="img" AND MUST STAY THAT WAY. Its aria-label is the only
     place the full "x out of 5 stars" is announced; re-roling it as a link would
     delete that. It gets the click, never the role.

     ⚠️ ENTER ONLY. role="link" activates on Enter; Space is button semantics and
     would also swallow the page scroll.

     🛑 NO PIXEL OFFSET HERE. scrollIntoView honours scroll-margin-top, which the
     stylesheet sets from the runtime --header-height. Never reintroduce a
     hard-coded offset in this file.

     ⚠️ FAILS OPEN. Zero-review products render no rating block at all (Liquid
     gates it on the metafield), so the loop simply finds nothing. */
  function linkRatingRow() {
    var target = document.querySelector('.gs-rc');
    if (!target) return;

    var containers = document.querySelectorAll('.product__info-container');

    for (var i = 0; i < containers.length; i++) {
      var info = containers[i];

      /* The Quick Add modal copies this whole section, related products and all.
         Only the real product page owns this behaviour. */
      if (typeof info.closest === 'function' && info.closest('quick-add-modal')) continue;

      var count = info.querySelector('.rating-count');
      if (!count) continue;
      if (count.getAttribute('data-gs-reviews-link') === 'true') continue;

      /* Never nest interactive controls: if Dawn or an app ever puts a link in
         there, leave the row completely alone. */
      if (info.querySelector('.rating-count a, .rating-count button')) continue;

      var parts = [info.querySelector('.rating'), info.querySelector('.rating-text'), count];

      for (var j = 0; j < parts.length; j++) {
        if (!parts[j]) continue;
        parts[j].setAttribute('data-gs-reviews-link', 'true');
        parts[j].addEventListener('click', function () {
          target.scrollIntoView({ block: 'start' });
        });
      }

      count.setAttribute('role', 'link');
      count.setAttribute('tabindex', '0');
      count.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        target.scrollIntoView({ block: 'start' });
      });
    }
  }

  /* 🔑 ONE PASS, THREE JOBS, ONE CALLER. Every presentation fix runs from here
     so the single observer below stays single. Never give any of them its own
     observer, listener or timer. */
  function applyPasses() {
    applyInitials();
    stripReplyPrefix();
    hideZeroReviewWidget();
    linkRatingRow();
  }

  /* 🛑 THE OBSERVER WATCHES THE SHOPIFY SECTION, NOT THE JUDGE.ME WIDGET. The
     widget element is injected by Judge.me's own script AFTER DOMContentLoaded,
     so an earlier build that observed it hit its early return, never created an
     observer, and never wrote a single attribute. The section wrapper is
     server-rendered and always present, and the widget's injection is itself a
     childList mutation that triggers the first real pass.

     ⚠️ THERE IS EXACTLY ONE OBSERVER IN THIS FILE AND IT SERVES EVERY PASS.
     Never add a second one for the avatar colour, the reply prefix or the
     zero-review shell -- the colour is written in the same loop as the
     initials, and every other pass runs from applyPasses above. This is also
     what makes the zero-review gate work: Judge.me injecting its widget IS a
     childList mutation, so the pass re-runs the moment the widget exists.

     ⚠️ THE WRITE-A-REVIEW WARM-UP IS DELIBERATELY NOT ROUTED THROUGH HERE. It
     was, and it did not work: the warm-up click produces no mutation inside
     this host, so the pass never ran. It now owns a single one-shot timer in
     onWriteClick instead.

     ⚠️ childList AND subtree ONLY. Never attributes or characterData: the
     passes set attributes and rewrite one nodeValue, so observing either would
     make them re-enter themselves. */
  function observe() {
    if (typeof MutationObserver !== 'function') return;

    var host = document.querySelector(SECTION);
    if (!host || host.dataset.gsInitialsObserved === 'true') return;
    host.dataset.gsInitialsObserved = 'true';

    new MutationObserver(function () {
      applyPasses();
    }).observe(host, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------------
     BOOT
     ------------------------------------------------------------------------ */

  /* ⚠️ BOTH STEPS, IN THIS ORDER, EVERY TIME. applyPasses covers reviews already
     in the DOM; observe covers everything Judge.me inserts later. Neither alone
     is enough. */
  function init(root) {
    initProxy(root);
    applyPasses();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
